@import "~@swisscom/sdx/stylesheets/sdx/variables/colors";
@import "~@swisscom/sdx/stylesheets/sdx/variables/sizes";
@import "~@swisscom/sdx/stylesheets/sdx/variables/grid";
@import "~@swisscom/sdx/stylesheets/sdx/mixins/breakpoints";
@import "~@swisscom/sdx/stylesheets/sdx/mixins/mediaqueries";
@import "~@swisscom/sdx/stylesheets/sdx/mixins/typography";
@import "~@swisscom/sdx/stylesheets/sdx/mixins/text";
@import "~@swisscom/sdx/stylesheets/sdx/mixins/misc";
@import "~@swisscom/sdx/stylesheets/sdx/mixins/core";
@import "~@swisscom/sdx/stylesheets/sdx/mixins/gradient";
@import "~@swisscom/sdx/stylesheets/sdx/mixins/button";
@import "~@swisscom/sdx/stylesheets/sdx/mixins/grid";
@import "~@swisscom/sdx/stylesheets/sdx/variables/global";
@import "~@swisscom/sdx/stylesheets/sdx/button/button";
@import "~@swisscom/sdx/stylesheets/sdx/images/images";
@import "~@swisscom/sdx/stylesheets/sdx/link/link";
@import "~@swisscom/sdx/stylesheets/sdx/typography/typography";
@import "~@swisscom/sdx/stylesheets/sdx/grid/grid";

.sticky-cta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: sticky;
  bottom: 8px;
  margin-top: 24px;
  padding: 16px;

  background: rgba(255, 255, 255, 0.75);
  box-shadow: 0 0 56px rgba(85, 84, 91, 0.4);

  border: 1px solid var(--sdx-color-gray-tint-8);
  border-radius: 20px;

  transform: scale(0.85);
  opacity: 0;
  transition:
    transform 0.4s ease-in-out,
    opacity 0.4s ease-in-out;
  pointer-events: none;

  &.visible {
    transform: scale(1);
    opacity: 1;
    pointer-events: auto;
  }

  .cta-image {
    width: 40px;
    height: 48px;
    margin-right: 16px;
    align-items: center;
    object-fit: cover;
  }

  .cta-title {
    color: var(--sdx-color-sc-navy);
    margin-bottom: 0;
  }

  .cta-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
  }

  .cta-description {
    color: var(--sdx-color-gray);
  }

  .cta-button {
    margin-left: auto;
    margin-right: 0;
  }
}

@media (max-width: 768px) {
  .sticky-cta {
    flex-direction: row;

    .cta-content {
      text-align: center;
    }

    .cta-button {
      align-self: center;
    }
  }
}

@media (max-width: 480px) {
  .sticky-cta {
    padding: 12px;
    margin: 16px 8px 8px 8px;
    flex-direction: row;
    align-items: center;

    .cta-content {
      flex: 1;
      text-align: left;
    }

    .cta-button {
      flex-shrink: 0;
      align-self: auto;
      margin-left: 8px;
    }
  }
}
